import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import NewCisgenderIneligibilityNoticeStep, {
	INewCisgenderIneligibilityNoticeStepProps,
} from '@ui/templates/NewCisgenderIneligibilityNoticeStep';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

interface IInformedConsentStepPageProps extends IFlowStepProps {}

const MECisgenderIneligibilityNoticeStepPage: FC<IInformedConsentStepPageProps> = ({
	path,
	stepKey,
}) => {
	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-estrogen-cisgender-ineligibility" }) {
				page_headline
				page_subheader
				page_description
				main_title
				main_content
				return_to_folx_label
			}
		}
	`);

	const refinedContent = keysToCamel(pageContent) as INewCisgenderIneligibilityNoticeStepProps;

	return (
		<NewCisgenderIneligibilityNoticeStep
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
			pageContent={refinedContent}
		/>
	);
};

export default MECisgenderIneligibilityNoticeStepPage;
